<form [formGroup]="followUpForm">
  <div class="row">
    <div class="col-lg-6">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{ 'APPOINTMENT_RELATED.FOLLOW_UP_DATE' | translate }}</mat-label>
        <input matInput [matDatepicker]="picker" [matDatepickerFilter]="dateFilter" [min]="minDate"
          formControlName="appointDate" [required]="required" readonly (dateChange)="onDateChange($event)">
        <mat-datepicker-toggle matIconSuffix [for]="picker" [disabled]="disabled"></mat-datepicker-toggle>
        <mat-datepicker #picker [color]="'primary'"></mat-datepicker>
        <mat-error *ngIf="followUpForm.get('appointDate')?.hasError('required')">
          {{ 'REQUIRED.SELECT_DATE' | translate }}
        </mat-error>
      </mat-form-field>
    </div>
    <div class="col-lg-6">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{ 'APPOINTMENT_RELATED.FOLLOW_UP_TIME' | translate }}</mat-label>
        <mat-select formControlName="appointTime" [required]="required">
          <mat-option *ngFor="let slot of timeSlots" [value]="slot.time">
            {{ slot.time }}
          </mat-option>
        </mat-select>
        <mat-spinner matSuffix *ngIf="isLoadingSlots" diameter="18"></mat-spinner>
        <mat-error *ngIf="followUpForm.get('appointTime')?.hasError('required')">
          {{ 'REQUIRED.SELECT_TIME' | translate }}
        </mat-error>
      </mat-form-field>
    </div>
  </div>
</form>
